import React from 'react'
import { TOASTY_ASSETS } from '../assets'

export interface ToastyProps {
  /** Size preset or custom class */
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | string
  /** Additional CSS classes */
  className?: string
  /** Alt text for accessibility */
  alt?: string
  /** Enable bounce animation */
  animated?: boolean
}

const sizeMap = {
  xs: 'h-6 w-6',     // 24px - Small icons
  sm: 'h-8 w-8',     // 32px - Chat avatars
  md: 'h-12 w-12',   // 48px - Default
  lg: 'h-24 w-24',   // 96px - Empty states
  xl: 'h-32 w-32',   // 128px - Loading screens
}

export const Toasty: React.FC<ToastyProps> = ({
  size = 'md',
  className = '',
  alt = 'Toasty',
  animated = false,
}) => {
  const sizeClass = size in sizeMap ? sizeMap[size as keyof typeof sizeMap] : size
  const animationClass = animated ? 'animate-bounce' : ''

  return (
    <img
      src={TOASTY_ASSETS.mascot}
      alt={alt}
      className={`${sizeClass} ${animationClass} ${className}`.trim()}
      loading="lazy"
    />
  )
}

// Convenience exports for common use cases

/** Small avatar for chat interfaces */
export const ToastyAvatar = (props: Omit<ToastyProps, 'size'>) => (
  <Toasty size="sm" {...props} />
)

/** Large animated loading state */
export const ToastyLoading = (props: Omit<ToastyProps, 'size' | 'animated'>) => (
  <Toasty size="xl" animated {...props} />
)
